import _ from 'lodash';
import storeProvider from '../storeProvider';

import { getSetting } from './Settings';

export const getStore = () => (storeProvider.getStore());

export const getState = () => {
  const store = getStore();
  if (store) {
    return store.getState();
  }

  return false;
};

export const fileObject = {
  id: null,
  uploadStatus: 'uploading',
  selected: true,
  uuid: null,
  name: null,
  description: null,
  original_name: null,
  public: false,
  restricted: false,
  metadata_group: null,
  terms: [],
  removedTerms: [],
  collections: [],
  custom_fields: [],
};

export const getCollectionsFromFiles = (files) => {
  const file = files.find(f => (f.collections));
  return file ? _.uniqBy(file.collections, 'uuid') : [];
};

export const getAccessTypeFromFiles = (files) => {
  if (files.length > 0 && files[0] !== null) {
    return {
      public: files[0].public,
    };
  }

  return {
    public: getSetting('default_file_access_type') === 'public',
  };
};

export const getStatusFromFiles = (files) => {
  if (files.length > 0 && files[0] !== null && files[0].status) {
    const everyStatusTheSame = files.every(f => f.status === files[0].status);

    if (everyStatusTheSame) return files[0].status;
  }

  const state = getState();

  const { statuses } = state.Files;
  const defaultStatus = statuses.find(fs => fs.default);

  return defaultStatus || null;
};
